export default __webpack_public_path__ + "static/media/Chillax-Semibold.8bb570e9.woff";